<script>
import { observeIntersection } from '@/helpers/intersection-observer'

export default {
  name: 'IntersectionObserver',
  props: {
    isEnabled: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      observer: null,
    }
  },

  watch: {
    isEnabled: 'observeIntersection',
  },

  mounted() {
    this.observeIntersection()
  },

  beforeDestroy() {
    this.disconnect()
  },

  methods: {
    observeIntersection() {
      if (this.isEnabled) {
        this.observer = observeIntersection(this.$el, this.onIntersection, { threshold: 0.7 })
      }
    },

    onIntersection() {
      this.$emit('on-intersection')
      this.disconnect()
    },

    disconnect() {
      this.observer?.disconnect()
    },
  },

  render() {
    return this.$slots.default
  },
}
</script>
